import React from 'react'

type HomeShellProps = {
  children: React.ReactNode
}

/**
 * Gemensam “page shell” för startsidan (exkl. Hero).
 * Skapar ny bakgrund/ytor så att sektioner känns som en enhetlig ny design.
 */
const HomeShell: React.FC<HomeShellProps> = ({ children }) => {
  return (
    <div className="relative">{children}</div>
  )
}

export default HomeShell

